import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { PublicService } from 'src/app/services/public/public.service';
import * as moment from "moment"

@Component({
  selector: 'app-applicationstatus',
  templateUrl: './applicationstatus.component.html',
  styleUrls: ['./applicationstatus.component.css']
})
export class ApplicationstatusComponent implements OnInit {

  constructor(private  publicService:PublicService,private spinnerService: Ng4LoadingSpinnerService, 
    public globalHelper: GlobalHelper) { }
  show='';
  StatusAlert='';
  SubmittedStatus=false;
  ApplicationStatus={
    AdmissionStatusID:0,
    AdmissionStatus:'',
    FirstName:'',
    MiddleName:'',
    LastName:'',
    ClassName:'',
    AdmissionStatusDesc:'',
    StudentID:0,
    FatherName:'',
    MotherName:'',
  };

  StudentEnquiryModel={
    DOB:'',
    RegistrationNumber:'',
    StudentID:0,
  }
  GetApplicationStatusByRegNo(valid) {
    this.show = '';
    this.StatusAlert = '';
    this.SubmittedStatus = true;
    if (valid) {
        this.spinnerService.show();
        this.StudentEnquiryModel.DOB = this.StudentEnquiryModel.DOB != null && this.StudentEnquiryModel.DOB != '' ? moment(this.StudentEnquiryModel.DOB).format('DD-MMM-YYYY') : '';
        this.publicService.GetApplicationStatusByRegNo(this.StudentEnquiryModel.DOB, this.StudentEnquiryModel.RegistrationNumber).subscribe((data) => {
            this.globalHelper.CheckActionStatus(data);
            if (data.webResponse.Status) {
                this.ApplicationStatus = data.ApplicationStatus[0];
                this.show = 'T';
                this.StudentEnquiryModel.StudentID = data.ApplicationStatus[0].StudentID;
                // this.GetStudentDetailsByStudentID();
            }
            else {
                this.StatusAlert = 'Please enter valid Registration No and Date of Birth';
            }
          this.spinnerService.hide();
            this.SubmittedStatus = false;
        })
    }
}
  ngOnInit() {
  }


  Print(StudentID) {
    var url = "Public/printapplication?StudentID=" + StudentID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}


}
